import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
    name: 'assetTypes',
    initialState: {
        value: {}
    },
    reducers: {
        setAuth: (state, action) => {
            state.value = action.payload;
        },
        clearAuth: (state) => {
            state.value = {};
        }
    }
});

export const { setAuth, clearAuth } = authSlice.actions;

export default authSlice.reducer;
